const localization = {
    cannot_delete_default_language: '{{languageTag}}はデフォルト言語として設定されており、削除できません。',
    invalid_translation_structure: 'データスキーマが無効です。入力を確認して、もう一度お試しください。',
};
export default localization;
